import React from 'react';
import { createPortal } from 'react-dom';
import '../../FlowchartView/components/ConfirmModal.css';

/**
 * DeleteTaskModal Component
 * 
 * Confirmation dialog for deleting tasks with recommendation to archive instead.
 * Uses the shared ConfirmModal styling with custom three-button layout.
 */
const DeleteTaskModal = ({ 
  isOpen, 
  taskName = '',
  onCancel, 
  onConfirmDelete,
  onArchiveInstead,
}) => {
  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onCancel?.();
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      onCancel?.();
    }
  };

  const modal = (
    <div 
      className="confirm-modal__backdrop" 
      onClick={handleBackdropClick}
      onKeyDown={handleKeyDown}
      tabIndex={-1}
    >
      <div className="confirm-modal__container" data-variant="danger" onClick={(e) => e.stopPropagation()}>
        <div className="confirm-modal__header">
          <div className="confirm-modal__icon-wrapper">
            <div className="confirm-modal__orbit" />
            <div className="confirm-modal__particle" />
            <div className="confirm-modal__particle confirm-modal__particle--secondary" />
            <div className="confirm-modal__icon confirm-modal__icon--danger">
              <span>⚠</span>
            </div>
          </div>
          <h3 className="confirm-modal__title">Delete Task?</h3>
        </div>
        
        <div className="confirm-modal__body">
          <p className="confirm-modal__message">
            <strong>"{taskName}"</strong>
          </p>
          <p className="confirm-modal__message" style={{ marginTop: '8px', opacity: 0.7 }}>
            This action cannot be undone. The task and all its data will be permanently deleted.
          </p>
          <div className="delete-task-modal__recommendation">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="16" x2="12" y2="12" />
              <line x1="12" y1="8" x2="12.01" y2="8" />
            </svg>
            <span>Consider archiving instead to preserve data and allow restoration.</span>
          </div>
        </div>
        
        <div className="confirm-modal__footer">
          <button 
            className="confirm-modal__btn confirm-modal__btn--cancel" 
            onClick={onCancel}
          >
            Cancel
          </button>
          <button 
            className="confirm-modal__btn confirm-modal__button--secondary" 
            onClick={() => {
              onArchiveInstead?.();
              onCancel();
            }}
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="21 8 21 21 3 21 3 8" />
              <rect x="1" y="3" width="22" height="5" />
              <line x1="10" y1="12" x2="14" y2="12" />
            </svg>
            <span style={{ marginLeft: '4px' }}>Archive Instead</span>
          </button>
          <button 
            className="confirm-modal__btn confirm-modal__btn--danger" 
            onClick={() => {
              onConfirmDelete?.();
              onCancel();
            }}
          >
            Delete Permanently
          </button>
        </div>
      </div>
    </div>
  );

  return createPortal(modal, document.body);
};

export default DeleteTaskModal;
